/**
 * @description Single source for the backend API base URL.
 * Env-driven so staging/prod builds point at the right domain (a domain, no port) via
 * REACT_APP_API_URL; the localhost fallback is for local dev only. Import `apiBase`
 * instead of repeating `process.env.REACT_APP_API_URL || 'http://localhost:3001'`.
 */
export const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/$/, '');

/**
 * Base URL of the donor/partner portal SPA, where a finished sign-in lands (`/signed-in`) and the
 * Terms and Privacy Policy live (`/terms`, `/privacy`). The portal is a separate deployment, so the
 * website links to it rather than routing to it. Override with REACT_APP_PORTAL_URL.
 */
export const portalBase = (process.env.REACT_APP_PORTAL_URL || 'https://portal.pawsitivefuture.org').replace(/\/$/, '');
